import { render, staticRenderFns } from "./HomeAtendente.vue?vue&type=template&id=47cef12e&scoped=true"
import script from "./HomeAtendente.vue?vue&type=script&lang=js"
export * from "./HomeAtendente.vue?vue&type=script&lang=js"
import style0 from "./HomeAtendente.vue?vue&type=style&index=0&id=47cef12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cef12e",
  null
  
)

export default component.exports